/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { PARSED_SEGMENT_DATA_FRAGMENT } from '../fragments/ParsedSegmentDataFragment'

export const PARSE_PSA_FILE = gql`
  mutation ParsePsaFile($file: Upload!) {
    parsePsaFile(file: $file) {
      segments {
        ...ParsedSegmentData
      }
    }
  }
  ${PARSED_SEGMENT_DATA_FRAGMENT}
`
